import { computed, ref } from "@vue/composition-api";
import store from "@/store";
import { useDefineChatbot } from "@/composables/defineChatbot";

export function useChatbotHelp() {

  const { messageHandler, myMessage } = useDefineChatbot()
  const isChatbotHelpOpen = computed(() => store.state.chatbot.isHelpViewOpen);

  const toggleChatbotHelp = ()=> {
    store.commit("chatbot/toggleChatbotHelp");
  }

  const closeChatbotHelp = ()=> {
    store.commit("chatbot/closeChatbotHelp");
  }

  const getHowRequestChart = ()=> {
    myMessage.value.body = 'explain to me how to request a chart'
    messageHandler()
  }

  const getListOfAlarms = ()=> {
    myMessage.value.body = 'generate a list of detection events by event type'
    messageHandler()
  }

  const getHeatMapOfAlarms = ()=> {
    myMessage.value.body = 'generate a heat map of alarms by status'
    messageHandler()
  }

  const getMoreExamplesOfCharts = ()=> {
    myMessage.value.body = 'give me examples of a chart request query'
    messageHandler()
  }

  const getHowRequestSpecificChart  = (typeChart)=> {
    myMessage.value.body = `teach me how to request a chart of ${typeChart}`
    messageHandler()
  }

  const getSboInformation  = ()=> {
    myMessage.value.body = `give informatiom about Omniview SBO platform`
    messageHandler()
  }

  const getHowAddOmnicloudCamera  = ()=> {
    myMessage.value.body = `help me to add a omnicloud camera`
    messageHandler()
  }


  return {
    isChatbotHelpOpen,
    toggleChatbotHelp,
    getHowRequestChart,
    getListOfAlarms,
    getHeatMapOfAlarms,
    getMoreExamplesOfCharts,
    getHowRequestSpecificChart,
    getSboInformation,
    getHowAddOmnicloudCamera,
    closeChatbotHelp
  }
}